import { Route, Routes } from "react-router";
import { HomePage } from "./pages/HomePage";
import { RootLayout } from "./layouts/RootLayout";
import { PageLayout } from "./layouts/PageLayout";
import { FormLayout } from "./layouts/FormLayout";
import { FormPage } from "./pages/FormPage";
import { DevLayout } from "./layouts/DevLayout";
import { FormThankYouPage } from "./pages/FormThankYouPage";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<RootLayout />}>
        <Route element={<PageLayout />}>
          <Route path="/" element={<HomePage />} />

          <Route path="forms" element={<FormLayout />}>
            <Route path="dev" element={<DevLayout />}>
              <Route path=":formId">
                <Route index element={<FormPage />} />
                <Route path="page/:pageIndex" element={<FormPage />} />
                <Route path="thank-you" element={<FormThankYouPage />} />
              </Route>
            </Route>
          </Route>

          <Route path="forms" element={<FormLayout />}>
            <Route path=":formId">
              <Route index element={<FormPage />} />
              <Route path="page/:pageIndex" element={<FormPage />} />
              <Route path="thank-you" element={<FormThankYouPage />} />
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
};
